<div class="text-align-center display-flex flex-direction-column">
  <sb-stamp class="mb-4 mh-auto" [type]="'dimmed-yellow'">
    <sb-icon [name]="'flash'" [size]="'3'" />
  </sb-stamp>

  <h3 class="t-5@r color-void mb-4">{{ headlineCopy }}</h3>

  <div class="color-ash mb-6">
    For just {{ profile.costs.boost_message }} credits <span class="color-yellow">BOOST</span> your message and we'll
    highlight it in {{ profile.username }}'s inbox
  </div>

  <button sbButton [size]="'big'" [stretchable]="true" [variant]="buttonVariant" (click)="confirm()">
    {{ buttonCopy }}
  </button>
</div>
